export default {
  install(Vue) {
    Vue.prototype.$isPad = function () {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /ipad/i.test(userAgent);
    };
  },
};
